<template>
  <a
    href="javascript:;"
    class="dark-mode-switcher"
    :title="$t('changeContrast')"
  >
    <IconContrastSvg
      @click.prevent="darkModeToggle"
    />
  </a>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'DarkModeSwitcher',

  methods: {
    ...mapMutations('global', {
      darkModeToggle: 'SET_DARK_MODE'
    })
  }
}
</script>

<style lang="scss" scoped>
  .dark-mode-switcher {
    svg {
      $size: 20px;
      $color: nth($color-custom, 1);

      display: inline-block;
      width: $size;
      height: $size;
      cursor: pointer;
      transition: all 0.1s;
      fill: $color;
    }
  }
</style>
